// extracted by mini-css-extract-plugin
export var scrollArea = "_qp-0";